if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => {
          console.log('[product-form] add-to-cart status', response.status, response);
          // Handle 401 Unauthorized early (common when testing on localhost / preview proxy issues)
          if (response.status === 401) {
            // Show a clearer, developer-facing message when the local preview proxy blocks cart requests.
            const shopOrigin = (typeof window !== 'undefined' && window.shopUrl) ? window.shopUrl : null;
            const shopPreviewHint = shopOrigin ? `Open the store preview at ${shopOrigin} to test add-to-cart.` : 'Open the store preview (Shopify admin → Preview) to test add-to-cart.';
            const msg = `Add-to-cart blocked in local preview. ${shopPreviewHint} / Lokale Vorschau blockiert Warenkorbanforderungen.`;
            console.error('[product-form] add-to-cart 401 Unauthorized');
            this.handleErrorMessage(msg);
            // dispatch an event so other scripts can react (useful for debugging)
            try { this.dispatchEvent(new CustomEvent('cart:add_unauthorized', { detail: { status: 401 }, bubbles: true })); } catch (e) {}
            // Return a marker object to prevent the next .then() block from showing a generic error
            return { _errorHandled: true };
          }
          return response.text().then((text) => {
            try {
              return text ? JSON.parse(text) : null;
            } catch (err) {
              console.error('[product-form] Failed to parse add-to-cart JSON', err, text);
              return null;
            }
          });
        })
        .then((responseJSON) => {
          console.log('[product-form] add-to-cart responseJSON', responseJSON);
          // Skip generic error handling if error was already handled (e.g., 401)
          if (responseJSON && responseJSON._errorHandled) {
            this.error = true;
            return;
          }
          if (!responseJSON) {
            this.handleErrorMessage('Fehler beim Hinzufügen zum Warenkorb.');
            return;
          }

          if (responseJSON.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: responseJSON.description, message: responseJSON.message});
            this.handleErrorMessage(responseJSON.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (soldOutMessage) {
              this.submitButton.setAttribute('aria-disabled', true);
              const span = this.submitButton.querySelector('span'); if (span) span.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
            }
            this.error = true;
            return;
          }

          if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;

          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { if (typeof this.cart.renderContents === 'function') this.cart.renderContents(responseJSON); });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            if (typeof this.cart.renderContents === 'function') {
              this.cart.renderContents(responseJSON);
            } else if (typeof this.cart.render === 'function') {
              this.cart.render(responseJSON);
            }
          }

          // try to open cart UI if available
          try {
            if (typeof this.cart.open === 'function') this.cart.open();
            else if (this.cart.dispatchEvent) this.cart.dispatchEvent(new CustomEvent('cart:open'));
            else {
              const cartToggle = document.querySelector('[data-cart-toggle], [data-drawer-id="cart"], .cart-toggle, .js-cart-open');
              if (cartToggle) cartToggle.click();
            }
          } catch (e) {
            console.warn('[product-form] failed to auto-open cart', e);
          }
        })
        .catch((e) => {
          console.error('[product-form] add-to-cart fetch error', e);
          this.handleErrorMessage('Fehler beim Hinzufügen zum Warenkorb.');
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          const spinner = this.querySelector('.loading-overlay__spinner'); if (spinner) spinner.classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

let acc = document.getElementsByClassName("size-finder__link");
let ic;

for (ic = 0; ic < acc.length; ic++) {
  acc[ic].addEventListener("click", function() {
    this.classList.toggle("active");
    let panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
}
